import React, { useState, useRef, useMemo, useEffect } from "react";
import { jsPDF } from "jspdf";
import html2canvas from "html2canvas";
import "../../../assets/styles/local/Quote-client.sign.css";
import ReactSignatureCanvas from "react-signature-canvas";
import { BsDownload, BsPenFill } from "react-icons/bs";
import { TfiPencilAlt2 } from "react-icons/tfi";
import { useParams } from "react-router-dom";
import { axiosInstance } from "../../../redux/constants/axiosInstance";
import { API_URL } from "../../../redux/constants/type";
import { formattedCurrency } from "../../../utils/helpers/calculateTime";
import { useDispatch } from "react-redux";
import { Editor } from "react-draft-wysiwyg";
import { europeanFormatWithSymbol } from "../../../utils/European-Format/NumberFormatter";
//import { EditorState, convertFromRaw } from "draft-js";
import simpleRequest from "../../../utils/helpers/simpleRequest";

import moment from "moment";
import { FaGripLines } from "react-icons/fa";
import { RiEraserFill } from "react-icons/ri";
import { handleGeneralNotification } from "../../../utils//helpers/notifications";
import { useHistory } from "react-router-dom";
import { AddDocumentToProject } from "../../../redux/actions/action";
import { ROLES } from "../../../utils/helpers/userRole";
import calender from "../../../assets/images/Calendar3.svg";
import {
  EditorState,
  ContentState,
  convertFromRaw,
  convertFromHTML,
} from "draft-js";

const QuoteClientSign = () => {
  // on send click, notification to owners/managers/users -> client has signed the quote. => The project manager has been notified about the successful signing of the quote.
  const roleAccess = window.localStorage.getItem("roleid");
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const history = useHistory();
  const { quoteid } = useParams();
  const [quote, setQuote] = useState(null);
  const signRef = useRef(null);
  const refSignatureContainer = useRef(null);
  const [hasSignature, setHasSignature] = useState(false);
  const draggedItem = useRef(null);
  const draggedOverItem = useRef(null);
  const [sending, setSending] = useState(false);
  const [activeTab, setActiveTab] = useState("General");
  const HIGH = process.env.REACT_APP_QUOTE_PRIORITY_HIGH;
  const [quoteDetails, setQuoteDetails] = useState({
    quoteCode: "",
    status: "",
    projectName: "",
    projectCode: "",
    projectId: "",
    quoteDate: "",
    mainContact: "",
    reference: "",
    priorityId: HIGH,
  });
  const [sections, setSections] = useState([]);

  const fetchQuote = async (quoteId) => {
    const resp = await simpleRequest(`/api/quote/${quoteId}`, "get", {});
    console.log("res FROM fetchQuote===>", resp);
    if (resp?.status === true) {
      const { data } = resp;
      setQuoteDetails({
        quoteCode: data?.quotecode,
        status: data?.status,
        quoteDate: new Date(data?.quoteDate || new Date()),
        projectCode: data?.projectcode,
        projectId: data?.projectid,
        projectName: data?.projectname,
        mainContact: data?.maincontact,
        reference: data?.reference,
        priorityId: data?.priorityid,
      });
      const sectionsList = [...data?.sections];
      let list = [];
      sectionsList?.map((section) => {
        let subSections = [];
        section?.subSections?.map((subSection) => {
          let sub;
          try {
            // Attempt to parse as JSON (DraftJS raw content)
            const content = convertFromRaw(JSON.parse(subSection?.description));
            sub = {
              ...subSection,
              description: EditorState.createWithContent(content),
            };
          } catch (e) {
            // If parsing fails, treat it as HTML
            const content = ContentState.createFromBlockArray(
              convertFromHTML(subSection?.description),
            );
            sub = {
              ...subSection,
              description: EditorState.createWithContent(content),
            };
          }
          subSections.push(sub);
        });
        list.push({ ...section, subSections });
      });
      setSections([...list]);
    }
  };

  useEffect(() => {
    fetchQuoteByKey((quoteId) => {
      fetchQuote(quoteId);
    });
  }, [quoteid]);

  const fetchQuoteByKey = (cb) => {
    axiosInstance.get(`${API_URL}/api/quote/${quoteid}/sign`).then((res) => {
      let updatedData = updateQuoteData(res.data.data);
      setQuote(updatedData);
      cb && cb(updatedData.quoteId);
    });
  };

  const updateQuoteData = (data) => {
    data.total = 0;
    data.sections.forEach((section) => {
      section.subSections.forEach((subsection, sbIndex) => {
        if (subsection.indexPosition == null) {
          subsection.indexPosition = sbIndex;
        }
      });
      data.total += section.totalAmount;
    });
    return data;
  };

  const handleSubsectionStatusChange = (item, status) => {
    let oldData = { ...quote };
    oldData.sections.forEach((section) => {
      if (section.sectionid === item.sectionid) {
        section.subSections.forEach((subsection) => {
          if (subsection.subsectionid === item.subsectionid) {
            subsection.isApproved = status;
          }
        });
      }
    });
    setQuote({ ...oldData });
  };

  const onSignEnd = () => {
    setHasSignature(true);
  };

  const clearCanvas = () => {
    signRef.current?.clear();
    setHasSignature(false);
  };

  const handleSignedByChange = (e) => {
    let oldQuote = { ...quote };
    oldQuote.signedBy = e.target.value;
    setQuote({ ...oldQuote });
  };

  const scrollToSignatureContainer = () => {
    if (refSignatureContainer.current) {
      refSignatureContainer.current.scrollIntoView({ behavior: "smooth" });
    }
  };

  const handleSendClick = () => {
    if (signRef.current && signRef.current.isEmpty()) {
      scrollToSignatureContainer();
      return;
    }
    setSending(true);
    let params = { ...quote };
    params.signature = signRef.current.toDataURL();
    axiosInstance
      .post(`${API_URL}/api/quote/${quoteid}/sign`, params)
      .then((res) => {
        handleGeneralNotification(
          {
            notificationType: "CUSTOM",
            text: "The project manager has been notified about the successful signing of the quote",
          },
          false,
        );
        fetchQuoteByKey(() => setSending(false));
        AddingProjectDocument();
      });
  };

  const handleDragSort = (sectionIndex) => {
    let oldQuote = { ...quote };
    let draggedItemContent = oldQuote.sections[sectionIndex].subSections.splice(
      draggedItem.current,
      1,
    )[0];
    oldQuote.sections[sectionIndex].subSections.splice(
      draggedOverItem.current,
      0,
      draggedItemContent,
    );
    oldQuote.sections[sectionIndex].subSections.forEach(
      (item, index) => (item.indexPosition = index),
    );
    draggedItem.current = null;
    draggedOverItem.current = null;
    setQuote({ ...oldQuote });
  };

  const downloadDocument = () => {
    const input = document.getElementById("divToDownload");
    console.log("LN 200", input);

    html2canvas(input).then((canvas) => {
      const margin = 10;
      const pageWidth = 210;
      const pageHeight = 297;
      const imgWidth = pageWidth - margin * 2;
      const usableHeight = pageHeight - margin * 2;

      const scale = canvas.width / imgWidth;
      const pagePixelHeight = Math.floor(usableHeight * scale);

      const pdf = new jsPDF("p", "mm", "a4");
      const pageCanvas = document.createElement("canvas");
      const ctx = pageCanvas.getContext("2d");

      pageCanvas.width = canvas.width;

      let y = 0;
      let page = 0;

      while (y < canvas.height) {
        const sliceHeight = Math.min(pagePixelHeight, canvas.height - y);

        pageCanvas.height = sliceHeight;

        ctx.clearRect(0, 0, canvas.width, sliceHeight);
        ctx.drawImage(
          canvas,
          0,
          y,
          canvas.width,
          sliceHeight,
          0,
          0,
          canvas.width,
          sliceHeight,
        );

        if (page > 0) {
          pdf.addPage();
        }

        pdf.addImage(
          pageCanvas.toDataURL("image/png"),
          "PNG",
          margin,
          margin,
          imgWidth,
          sliceHeight / scale,
        );

        y += sliceHeight;
        page++;
      }
      // pdf.output('dataurlnewwindow')

      // for pdf print download start.
      let workspaceName = localStorage.getItem("workspaceName")?.split("-")[0];
      // let selectedProject = localStorage.getItem("projectForPrint");
      let selectedQuoteNo = localStorage.getItem("QuoteNoForPrint");
      let selectedClientName = localStorage.getItem("clientNameForPrint");
      let employeeName = localStorage.getItem("firstname");

      let pdfTitle = `${selectedClientName ?? ""}-${
        selectedQuoteNo ?? ""
      }-${workspaceName}-${moment(new Date()).format(
        "YYYY.MM.DD, h:mm a",
      )}.pdf`;
      // for pdf print download end.

      pdf.save(pdfTitle);
    });
  };

  const RenderSection = ({ item, index }) => {
    return (
      <div className="quote-client-sign-section-container">
        <div className="quote-client-sign-section-header">
          <div className="quote-client-sign-section-header-name">
            {item.sectionName}
          </div>
          <div className="quote-client-sign-section-header-status text-center">
            Status
          </div>
        </div>
        <div className="quote-client-sign-section-details">
          <div className="quote-client-sign-sub-section-container header">
            <div></div>
            <div className="quote-client-sign-header-light-text">Material</div>
            <div className="quote-client-sign-header-light-text text-center">
              Qty
            </div>
            <div className="quote-client-sign-sub-section-total">Total</div>
            <div className="quote-client-sign-header-dark-text text-center">
              Approve
            </div>
          </div>
          {item.subSections.map((subsection, subIndex) => (
            <RenderSubSection
              key={`sub-section-${subIndex}`}
              item={subsection}
              index={subIndex}
              sectionIndex={index}
            />
          ))}
          <div className="quote-client-sign-sub-section-container footer">
            <div className="quote-client-sign-sub-section-footer-total">
              Total Section
            </div>
            <div></div>
            <div className="quote-client-sign-header-light-text text-center"></div>
            <div className="quote-client-sign-sub-section-total quote-client-sign-sub-section-footer-total">
              {formattedCurrency(item.totalAmount)}
            </div>
            <div className="quote-client-sign-header-dark-text text-center"></div>
          </div>
        </div>
      </div>
    );
  };

  const RenderSubSection = ({ item, sectionIndex, index }) => {
    return (
      <div
        className="quote-client-sign-sub-section-container"
        key={index}
        onDragStart={(e) => (draggedItem.current = index)}
        onDragEnd={() => handleDragSort(sectionIndex)}
        onDragEnter={(e) => (draggedOverItem.current = index)}
        onDragOver={(e) => e.preventDefault()}
      >
        <div className="position-relative">
          {!quote.isSigned && (
            <div
              className="quote-sub-section-drag"
              draggable={true}
              style={{ cursor: "grab" }}
            >
              <FaGripLines color="#70707080" size={10} />
            </div>
          )}
          <img
            src={item.cover}
            className="quote-client-sign-sub-section-part-image"
          />
        </div>
        <div>
          <div className="quote-client-sign-sub-section-part-code">
            {item.productPartCode}
          </div>
          <div className="quote-client-sign-sub-section-part-name">
            {item.productPartName}
          </div>
        </div>
        <div className="quote-client-sign-sub-section-qty text-center">
          {item.qty}
        </div>
        <div className="quote-client-sign-sub-section-total bg-sub-section-total no-border">
          {formattedCurrency(item.total)}
        </div>
        <div className="text-center">
          {quote.isSigned ? (
            <>
              <div className="quote-client-sign-sub-section-qty">
                {item.isApproved ? "Approved" : ""}
              </div>
            </>
          ) : (
            <>
              <input
                type="checkbox"
                className="quote-client-sign-section-status-checkbox"
                id={`sub-section-approved-${item.subsectionid}`}
                checked={item.isApproved}
                onChange={(e) =>
                  handleSubsectionStatusChange(item, e.target.checked)
                }
              />
              <label
                htmlFor={`sub-section-approved-${item.subsectionid}`}
              ></label>
            </>
          )}
        </div>
      </div>
    );
  };

  const getFileFromBase64 = (string64, fileName) => {
    const trimmedString = string64.replace(
      "data:application/pdf;filename=generated.pdf;base64,",
      "",
    );
    const imageContent = atob(trimmedString);
    const buffer = new ArrayBuffer(imageContent.length);
    const view = new Uint8Array(buffer);

    for (let n = 0; n < imageContent.length; n++) {
      view[n] = imageContent.charCodeAt(n);
    }
    const type = "application/pdf";
    const blob = new Blob([buffer], { type });
    return new File([blob], fileName, {
      lastModified: new Date().getTime(),
      type,
    });
  };
  const AddingProjectDocument = () => {
    const input = document.getElementById("divToDownload");

    html2canvas(input).then((canvas) => {
      let imgWidth = 210;
      let pageHeight = 295;
      let imgHeight = (canvas.height * imgWidth) / canvas.width;
      let heightLeft = imgHeight;
      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF("p", "mm", "a4");
      let position = 0;
      pdf.addImage(imgData, "JPEG", 0, 0);
      pdf.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight + 10);
      heightLeft -= pageHeight;

      while (heightLeft >= 0) {
        position = heightLeft - imgHeight;
        pdf.addPage();
        pdf.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight + 10);
        heightLeft -= pageHeight;
      }
      // pdf.output('dataurlnewwindow');
      let res = pdf.output("datauristring");
      let file = getFileFromBase64(res, `document-${quote.quoteid}`);
      const formData = new FormData();
      formData.append("file", file);
      // handleGeneralNotification(
      //   { notificationType: "CUSTOM", text: "Your document is loading." },
      //   false
      // );
      try {
        axiosInstance
          .put(`${API_URL}/api/Files/UploadToS3`, formData, {
            headers: {
              Accept: "*/*",
              "Content-Type": "multipart/form-data",
            },
          })
          .then((response) => {
            if (response.status == 200) {
              handleGeneralNotification(
                {
                  notificationType: "CUSTOM",
                  text: "Document Uploaded successfully!",
                },
                false,
              );
              const user = window.localStorage.getItem("userid");
              dispatch(
                AddDocumentToProject(user, quote?.projectid, [
                  {
                    documentname: `document-${quote.quoteid}`,
                    documentextension: "pdf",
                    documentcontent: "string",
                    link: response.data[0],
                    documentsize: "12kb",
                  },
                ]),
              );
            }
          });

        // setDataBind([...filelist]);
      } catch (error) {
        console.error(error);
        // setIsError(error.message);
      }
      // else pdf.save("download.pdf");
    });
  };

  const handleUseEraser = () => {
    let canvas = document.getElementById("quote-signature-canvas");
    let context = canvas.getContext("2d");
    context.globalCompositeOperation = "destination-out";
    context.strokeStyle = "rgba(239, 239, 239, 1)";
    context.lineWidth = 15;
  };
  const handleDraw = () => {
    let canvas = document.getElementById("quote-signature-canvas");
    let context = canvas.getContext("2d");
    context.globalCompositeOperation = "source-over";
    context.lineWidth = 15;
  };

  const isSendButtonDisabled = useMemo(() => {
    return (
      !(hasSignature || (quote && quote.isSigned) || sending) ||
      !(quote && quote.signedBy)
    );
  }, [hasSignature, quote, sending]);

  if (loading || !Boolean(quote)) {
    return "Loading...";
  }

  return (
    <div className="container-fluid quote-client-sign p-0">
      <nav className="header-nav">
        <div className="d-flex">
          <img src={quote.company.logo} width={150} height={35} alt="logo" />
        </div>
        <div className="container">
          <div className="d-flex justify-content-end">
            {roleAccess !== ROLES.VIEWER && roleAccess !== ROLES.USER && (
              <button
                className="btn-app-primary"
                disabled={isSendButtonDisabled}
                onClick={handleSendClick}
              >
                Send
              </button>
            )}
          </div>
        </div>
      </nav>
      <section className="header-action-section">
        <div className="container">
          <div className="action-bar">
            {roleAccess !== ROLES.VIEWER && roleAccess !== ROLES.USER && (
              <div
                className="action-button"
                onClick={scrollToSignatureContainer}
              >
                <div className="action-button-label">
                  {hasSignature || quote.isSigned ? "Signed" : "Sign"}
                </div>
                <div className="action-button-icon">
                  <BsPenFill color="#fff" />
                </div>
              </div>
            )}
            <div className="action-button" onClick={() => downloadDocument()}>
              <div className="action-button-label">Download</div>
              <div className="action-button-icon">
                <BsDownload color="#fff" />
              </div>
            </div>
          </div>
        </div>
      </section>
      <main>
        <div className="container" id="divToDownload">
          <div className="block-headig-text section-title-text">
            Commercial Proposal
          </div>
          <div className="introduction-text">
            This document is an official quotation for client's review and
            approval.
            <br />
            <br />
            Outlined in the document is a detailed breakdown of expenses
            encompassing labor, materials, and associated costs required for the
            successful completion of the project/milestone of a project.
            <br />
            <br />
            In confirming your acceptance of the quote, your signature on this
            document signifies acknowledgment and agreement to all outlined
            expenses. To facilitate a smooth progression of the project, we
            kindly request that you sign and send digitally a document at the
            nearest time.
            <br />
            <br />
          </div>
          <div className="block-headig-text quote-title-text">Quote</div>
          <div className="frcb quote-n-box-tab-prob" style={{ padding: "0" }}>
            <div style={{ overflow: "auto", width: "100%" }}>
              <div
                className="frc"
                style={{ columnGap: "1.5rem", minWidth: "500px" }}
              >
                <div
                  className={`fc single-box ${
                    activeTab === "General" && "active"
                  }`}
                  onClick={() => setActiveTab("General")}
                >
                  General
                </div>
                <div
                  className={`fc single-box ${
                    activeTab === "Other Conditions" && "active"
                  }`}
                  onClick={() => setActiveTab("Other Conditions")}
                >
                  Other <br /> Conditions
                </div>
                <div
                  className={`fc single-box ${
                    activeTab === "Points of attention" && "active"
                  }`}
                  onClick={() => setActiveTab("Points of attention")}
                >
                  Points of <br /> attention
                </div>
                <div
                  className={`fc single-box ${
                    activeTab === "Term & Condition" && "active"
                  }`}
                  onClick={() => setActiveTab("Term & Condition")}
                >
                  Term & Condition
                </div>
              </div>
            </div>
          </div>
          <div className="quote-n-sections-main" style={{ marginTop: "0" }}>
            {activeTab === "General" && (
              <div
                className="quote-n-sections-main-1"
                style={{ padding: "2rem" }}
              >
                <div className="st-single-stage-div">
                  <p className="st-single-stage-label">Date</p>
                  <section className="frc" style={{ columnGap: "8px" }}>
                    <img src={calender} />
                    <p className="quote-n-contact-text">
                      {moment
                        .utc(new Date(quoteDetails?.quoteDate))
                        .format("DD.MM.yyyy")}
                    </p>
                  </section>
                </div>
                <div className="st-single-stage-div">
                  <label className="st-single-stage-label">Project</label>
                  <p className="quote-n-project-text">
                    {quoteDetails?.projectCode} | {quoteDetails?.projectName}
                  </p>
                </div>
                <div className="st-single-stage-div">
                  <label className="st-single-stage-label">Main Contact</label>
                  <p className="quote-n-contact-text">
                    {quoteDetails?.mainContact}
                  </p>
                </div>
                <div className="st-single-stage-div">
                  <label className="st-single-stage-label">Reference</label>
                  <p className="quote-n-contact-text">
                    {quoteDetails?.reference}
                  </p>
                </div>
              </div>
            )}
            <div className="quote-n-sections-main-2">
              <div className="fc" style={{ rowGap: "1rem", width: "100%" }}>
                {sections
                  ?.find((item) => item?.sectionName === activeTab)
                  ?.subSections?.map((subSection, index) => {
                    return (
                      <SingleSubSection
                        key={`${activeTab}-${index}`}
                        title={subSection?.title}
                        description={subSection?.description}
                        subSectionParts={subSection?.subSectionParts}
                        subSection={subSection}
                        activeTab={activeTab}
                      />
                    );
                  })}
              </div>
            </div>
          </div>
          {/* <div className="quote-section-container">
            {quote.sections.map((section, index) => (
              <RenderSection key={`section-${index}`} item={section} index={index} />
            ))}
          </div> */}
          <div
            className="quote-signature-container"
            ref={refSignatureContainer}
          >
            <div className="quote-signature-label">Signature</div>
            <div className="d-flex align-items-center justify-content-center">
              <div className="position-relative">
                {!quote.isSigned && (
                  <>
                    <ReactSignatureCanvas
                      ref={signRef}
                      backgroundColor="#d7d7d74a"
                      onEnd={onSignEnd}
                      canvasProps={{
                        width: quote.isSigned ? 0 : 754,
                        height: quote.isSigned ? 0 : 291,
                        id: "quote-signature-canvas",
                      }}
                    />
                    <div
                      className="signature-clear-button"
                      onClick={clearCanvas}
                    >
                      Clear
                    </div>
                    <div className="signature-pen-button">
                      <TfiPencilAlt2
                        color="#7E7E7E"
                        size={18}
                        fill="#7E7E7E"
                        onClick={() => handleDraw()}
                      />
                    </div>
                    <div
                      className="signature-eraser-button"
                      onClick={handleUseEraser}
                    >
                      <RiEraserFill color="#7E7E7E" size={18} />
                    </div>
                  </>
                )}
                {quote.isSigned && (
                  <img
                    src={quote.signature}
                    height={291}
                    width={754}
                    className="signature-image"
                  />
                )}
                <div className="signature-horizontal-line"></div>
              </div>
            </div>
          </div>
          <div className="quote-form">
            <div className="row" style={{ width: 754 }}>
              <div className="col-8">
                <div style={{ width: "80%" }}>
                  <input
                    className="quote-input"
                    name="quote-signed-by"
                    value={quote.signedBy}
                    onChange={handleSignedByChange}
                    disabled={quote.isSigned}
                    readOnly={quote.isSigned}
                  />
                  <label>Signed By</label>
                </div>
              </div>
              <div className="col-4">
                <div className="quote-input" name="quote-date">
                  {moment(quote.signedAt).format("DD.MM.YYYY")}
                </div>
                <label>Date</label>
              </div>
            </div>
          </div>
          <div className="d-flex align-items-center justify-content-center">
            {roleAccess !== ROLES.VIEWER && roleAccess !== ROLES.USER && (
              <button
                className="btn-app-primary"
                disabled={isSendButtonDisabled}
                onClick={handleSendClick}
              >
                Send
              </button>
            )}
          </div>
          <div className="quote-footer">
            <div className="d-flex align-items-end justify-content-between gap-3">
              <div className="text-company-vat">
                VAT No. {quote.company.vatNo}
              </div>
              <div className="text-company-details">
                <span className="fw-bold">{quote.company.name}</span>
                <span>{quote.company.address}</span>
              </div>
              <div className="text-client-details">
                <span className="fw-bold">www.website.com</span>
                <span>+35 1234 5678 email@example.com</span>
                <span>KvK no. 000000000</span>
              </div>
            </div>
            <div className="text-powered-by">
              Powered by www.spire.solutions
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

const SingleSubSection = ({
  title,
  description,
  subSectionParts,
  subSection,
  activeTab,
}) => {
  const [editorState, setEditorState] = useState(description);
  const [typing, setTyping] = useState(false);

  const textEnd = { textAlign: "end" };

  const changeApplied = (e) => {
    setEditorState(e);
    setTyping(true);
  };

  return (
    <div className="quote-n-single-section frc">
      <div className="quote-n-single-section-main fc">
        <div
          className="quote-n-single-section-head frcb"
          style={{ columnGap: "1rem" }}
        >
          <p className="quote-n-single-section-title-input">{title}</p>
          {subSection?.totalizeAmountInSectionHeader === 1 && (
            <p
              className="quote-n-subSection-total"
              style={{
                display: activeTab === "Term & Condition" ? "none" : "",
              }}
            >
              {europeanFormatWithSymbol(subSection?.total)}
            </p>
          )}
        </div>
        <div>
          {subSectionParts?.length > 0 && (
            <div className="quote-n-subsection-prod-main-box fc">
              <div className="quote-n-subsection-prod-topbox">
                <p>Item Description</p>
                <p style={{ textAlign: "center" }}>Measure Unit</p>
                <p style={textEnd}>Unit Price</p>
                <p style={textEnd}>Qty.</p>
                <p style={textEnd}>Total</p>
              </div>
              <div className="quote-n-subsection-underline-dashed" />
              <div
                className="fc"
                style={{ rowGap: "0.5rem", padding: "0.5rem 1rem" }}
              >
                {subSectionParts?.map((part, i) => {
                  return (
                    <div className="quote-n-subsection-prod-single" key={i}>
                      <p>{part?.productPartName}</p>
                      <p style={{ textAlign: "center" }}>{part?.measureUnit}</p>
                      <p style={textEnd}>
                        {europeanFormatWithSymbol(+part?.unitPrice)}
                      </p>
                      <p style={textEnd}>{part?.qty}</p>
                      <p style={textEnd}>
                        {europeanFormatWithSymbol(+part?.total)}
                      </p>
                    </div>
                  );
                })}
              </div>
            </div>
          )}
          <div className="quote-n-editor-div" id="quotes-sign-height">
            <Editor
              placeholder=""
              editorState={editorState}
              readOnly={true}
              onEditorStateChange={changeApplied}
              wrapperClassName="wrapper-class"
              editorClassName="write-message"
              toolbarClassName="toolbar-dis-none"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default QuoteClientSign;
